import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { setPageTitle } from "./App"
import { TranslateFunction } from "./models/Common"

export default function Page404() {
  const { t } = useTranslation()
  const tf: TranslateFunction = t

  useEffect(() => {
    setPageTitle(tf("error404.title"))
  }, [])

  return (
    <div className="error-page page-404">
      <h1>{tf("error404.title")}</h1>
      <p>{tf("error404.description")}</p>
    </div>
  )
}
